function setColorCode(){
    let storedColorCode = JSON.parse(localStorage.getItem("colorCode"));
    let stroedColorInPermissiom = JSON.parse(localStorage.getItem("permissions"))
//    document.documentElement.style.setProperty('--background-color', '#2b303b');
//    document.documentElement.style.setProperty('--sub-menus', '#272b35');
//    document.documentElement.style.setProperty('--button-colors', '#48b0f7');
//     console.log(stroedColorInPermissiom)
//     if (storedColorCode && storedColorCode.backgroundColor && storedColorCode.subMenus) {
//         document.documentElement.style.setProperty('--background-color', storedColorCode.backgroundColor);
//       document.documentElement.style.setProperty('--sub-menus', storedColorCode.subMenus);
//       document.documentElement.style.setProperty('--button-colors', storedColorCode.backgroundColor);
// }
// else if( stroedColorInPermissiom && stroedColorInPermissiom.app_theme && stroedColorInPermissiom.app_theme.backgroundColor && stroedColorInPermissiom.app_theme.subMenus){
//     document.documentElement.style.setProperty('--background-color', stroedColorInPermissiom.app_theme.backgroundColor);
//     document.documentElement.style.setProperty('--sub-menus', stroedColorInPermissiom.app_theme.subMenus);
//     document.documentElement.style.setProperty('--button-colors', stroedColorInPermissiom.app_theme.backgroundColor);
// }
// else{
//     document.documentElement.style.setProperty('--background-color', '#21252d');
//       document.documentElement.style.setProperty('--sub-menus', '#424242');
//       document.documentElement.style.setProperty('--button-colors', '#48b0f7');
// }
}

module.exports = {
    setColorCode,
}



// WEBPACK FOOTER //
// ./src/utils/setColor.js